import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { PasswordService } from 'src/app/auth/services/password.service';
import { UserKeyInput } from 'src/app/auth/user-password.model';
import { UserService } from 'src/app/core/user.service';
import { ErrCode, User } from 'src/app/shared/models';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-dialog-password-recovery',
  templateUrl: './dialog-password-recovery.component.html',
  styleUrls: ['./dialog-password-recovery.component.scss']
})
export class DialogPasswordRecoveryComponent implements OnInit {

  @Input() user: User;
  @Input() showPasswordRecoveryDialog: boolean;
  @Output() showPasswordRecoveryDialogChange = new EventEmitter<boolean>();

  public isValidPassword: boolean = false;
  public errcode: ErrCode;
  public curPass: string = '';
  public incorrectPassError: string = '';
  public passwordRecoveryStatus : string;
  public keyData: UserKeyInput;

  constructor(
    private passwordService: PasswordService,
    private userService: UserService,
    private snackbarService: SnackbarService
  ){}

  ngOnInit(): void {
    this.passwordRecoveryStatus = this.user.is_resetpassword ? '1' : '0';
  }

  getPassword = (password: string) => {
    this.curPass = password;
    this.incorrectPassError = '';
  }

  togglePasswordRecovery = (event: MatSlideToggleChange) => {
    this.passwordRecoveryStatus = event.checked ? '1' : '0';
  }

  checkPassword = async () => {
  this.errcode = undefined;
  try {
      this.keyData = await this.passwordService.passwordValid(
          this.user.email,
          this.curPass
      );
      this.isValidPassword = true;
    } catch (ex) {
      this.errcode = ErrCode.fromException(ex);
      if (this.errcode.code == 8101) {
        this.incorrectPassError = 'Enter your password';
      }
  }
  }

  savePasswordRecovery = async () => {
    this.errcode = undefined;
    try {
      if (this.passwordRecoveryStatus == '1') {
          await this.passwordService.enablePassReset(this.curPass, this.keyData);
      } else {
          await this.passwordService.disablePassReset();
      }
      this.userService.refresh();
      const statusMessage = this.passwordRecoveryStatus == '1' ? 'enabled.' : 'disabled.';
      this.snackbarService.showMessage('success', 'Email-based password recovery ' + statusMessage);
      this.closePasswordRecoveryDialog();
  } catch (ex) {
      console.error('Error with ', ex);
      this.errcode = ErrCode.fromException(ex);
      if (!this.errcode.msg || this.errcode.msg === 'An unknown error occurred') {
        this.closePasswordRecoveryDialog();
        this.snackbarService.showMessage("critical", "Couldn’t complete action. Try again.");
      }
  }
  }

  closePasswordRecoveryDialog = () => {
    this.showPasswordRecoveryDialog = false;
    setTimeout(() => {
      this.showPasswordRecoveryDialogChange.next(false);
    });
  }
}
